import { flexPackageProductsUrl } from "../../core/constants/endpoints";
import { FlexProductModel } from "../model/FlexPackageModel";
import HttpClient from "../../core/helpers/HttpClient";

export abstract class FlexPackageRemoteDataSource {
  abstract getProducts(
    appPid?: number,
    packageId?: string
  ): Promise<FlexProductModel[]>;
}

export class FlexPackageRemoteDataSourceImpl extends FlexPackageRemoteDataSource {
  httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    super();
    this.httpClient = httpClient;
  }

  // mobile-api's ApplicationEndpoint.getFlexPackageProducts returns
  // response.getData() directly as the response body (a plain JSON array), matching
  // this repo's existing getConfigurationAndValues pattern -- confirmed against the
  // real controller code, not assumed.
  getProducts = (appPid?: number, packageId?: string) =>
    this.httpClient.request(
      `${flexPackageProductsUrl}/${appPid}/${packageId}/products`,
      {
        factory: (data) =>
          (data ?? []).map((it) => FlexProductModel.fromJson(it)),
      }
    );
}
